// extracted by mini-css-extract-plugin
export default {"bottomModal":"menuDetail_bottomModal__4dGMp","modal-dialog":"menuDetail_modal-dialog__6IR+U"};